export default {
  rooms: (state) => {
    return state.rooms[0];
  }
}
